<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Filters',
        body: [
          `The filters allow the user to focus their search on a specific
          district, school, date range and/or batch number. If the user has
          multi-district location access, the user may select a district and a
          school location if desired. The Process Date Range defaults to the
          past 30 days. If the user wishes to view older near matches, the
          user will alter the date range accordingly. The filter also allows
          the user to select the appropriate person type for the search if the
          user has access to more than one person type.`,
        ],
      },
      {
        header: 'Running the Report',
        body: [
          `Once the user has selected the desired parameters, click Customize.
          The Submission History Report Results panel will appear. This panel
          contains a summary header with the total person type count,
          district count, batch count and near match record count. The
          selected district data is displayed beneath the summary. If a
          specific school or batch number is included in the parameters, the
          data displayed will be appropriate the parameters selected.`,
        ],
      },
      {
        header: 'Drilling into the Report',
        body: [
          `On the Submission History Report Results panel the user can drill
          into the district profile by clicking the hyperlinked district name
          or drill into the near match data by clicking the double arrow,
          drill in icon under Actions. Drilling in takes the user to the
          school level and drilling in again takes the user to the near match
          count by batch number. Drilling in yet again give the user the
          option to resolve near matches which takes the user to the near
          match page or download the near matches or near match details.
          Again, if the parameters selected include a specific school or
          batch number the data displayed on the panel will match the
          resulting data level specified in the report customization.`,
        ],
      },
      {
        header: 'Downloading the Report',
        body: [
          `The user may select Generate Excel or Generate PDF reports on any
          level of the Submission History Report Results panel. Generate
          Excel will create a spreadsheet which the user will download
          through the web browser. Generate PDF will create a PDF file which
          the user can print or save. In addition, once the user has drilled
          into the specific batch profile level, the user may select Resolve
          or Download in the Next Steps panel.`,
        ],
      },
    ];
  },
};
</script>
